import TotalOversSetting from "./TotalOversSetting";

export default TotalOversSetting;
